import { rolePermissionsApi } from '../api';
import type { PermissionCatalogItem } from '../store/slices/rolePermissions/rolePermissionsSlice';

export interface RolePermissionsResponse {
  roles: string[];
  permissions: string[];
  rolePermissions: { [role: string]: string[] };
  catalog?: PermissionCatalogItem[];
  lockedRoles?: string[];
}

export interface UpdateRolePermissionsPayload {
  rolePermissions: { [role: string]: string[] };
}

const RolePermissionService = {
  /**
   * Obtener todos los roles, permisos y el catalogo con metadatos.
   * GET /api/role-permissions  (solo SUPPORT)
   */
  getRolePermissions: async (): Promise<{ data: RolePermissionsResponse }> => {
    const response = await rolePermissionsApi.fetchAll();
    return response as { data: RolePermissionsResponse };
  },

  /**
   * Actualizar los permisos de uno o mas roles.
   * POST /api/role-permissions/update  (solo SUPPORT)
   * El backend rechaza editar SUPPORT y asignar permisos support_only a otros roles.
   */
  updateRolePermissions: async (data: UpdateRolePermissionsPayload) => {
    const response = await rolePermissionsApi.addCustom('/update', data);
    return response;
  },
};

export default RolePermissionService;
